import { render, staticRenderFns } from "./main-mobile-slide.vue?vue&type=template&id=53217bc5&"
import script from "./main-mobile-slide.vue?vue&type=script&lang=js&"
export * from "./main-mobile-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports